<div class="banner">
  <div>
    <span *ngIf="content.labels.title" class="banner-container__title">
      {{ content.labels.title }}
    </span>
    <span *ngIf="content.labels.subtitle">
      {{ content.labels.subtitle }}
    </span>
  </div>
  <div>
    <img
      *ngIf="content.image.show"
      class="banner-card__image"
      [src]="content.image.src"
      [alt]="content.image.alt"
    />
    <span class="sr-only">{{ content.image.alt }}</span>
  </div>
</div>
